import Model, { attr } from '@ember-data/model';

class DeviceStatusModel extends Model {
  @attr('string') declare companyId: string;
  @attr('string') declare product: string;
  @attr('string') declare externalId: string;
  @attr('string') declare locationId: string | null;
  @attr('string') declare zoneId: string | null;
  @attr('string') declare connectionStatus: 'CONNECTED' | 'DISCONNECTED' | null;
  @attr('date') declare connectionStatusUpdatedAt: Date | null;
  @attr() declare telemetry: Record<string, unknown>;
  @attr('date') declare lastEnrolledAt: Date | null;

  get isConnected(): boolean {
    return this.connectionStatus === 'CONNECTED';
  }

  get appVersion(): string | null {
    const value = this.telemetry?.['app-version'];
    return typeof value === 'string' ? value : null;
  }

  get deviceType(): string | null {
    const value = this.telemetry?.['device-type'];
    return typeof value === 'string' ? value : null;
  }

  get isIpad(): boolean {
    return this.product === 'visitors';
  }
}

export default DeviceStatusModel;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'device-status': DeviceStatusModel;
  }
}
